import SimpleScrollbar from 'simple-scrollbar';

export default () => {

	const popup = document.querySelector('.js-search-popup');
	if (!popup) return;

	const field = popup.querySelector('.js-search-field');
	const suggested = popup.querySelector('.js-search-suggested');

	field.addEventListener('input', () => {
		if (field.value) {
			suggested.classList.add('is-hidden');

			setTimeout(() => {
				const scrolled = popup.querySelector('#predictive-search-results-list');
				if (scrolled) {
					SimpleScrollbar.initEl(scrolled);
				}
			}, 1000);
		}
		else {
			suggested.classList.remove('is-hidden');
		}
	});

	/* Search input clear function */
	const clearSearch = () => {
		field.value = '';
		popup.querySelector('#predictive-search').innerHTML = "";
		suggested.classList.remove('is-hidden');
	}

	/* Resetting and setting input focus on when popup opens */
	const searchPopupTrigger = document.querySelectorAll('div.js-open-popup[data-popup="search"]');
	searchPopupTrigger.forEach(el => {
		el.addEventListener('click', () => {
			clearSearch();
			setTimeout(function() {
				field.focus();
			}, 620);
		});
	});

	/* Clear button */
	popup.querySelector('.js-search-clear').addEventListener('click', (event) => {
		clearSearch();
		field.focus();
	});

	document.addEventListener('click', (event) => {
		if(event.target.classList.contains('js-search-page-clear')) {
			let searchfield = document.querySelector('.js-search-page-input');
			searchfield.value = ''; // clear the input value
			searchfield.focus(); // clear the input value
		}
	  });

	/* Suggested searches */
	const suggestions = suggested.querySelectorAll('.suggested__list li');
	suggestions.forEach(item => {
		item.addEventListener('click', function() {
            // Remove quotation marks and set the value to the search box
            field.value = item.textContent.replace(/“|”/g, '').trim();
			const event = new Event('input', {
				'bubbles': true,
				'cancelable': true
			});
			field.dispatchEvent(event);
			field.focus();
        });
	});
}
